import { Action, createReducer, on } from '@ngrx/store';
import { DomainSettingsList } from '../../models';
import {
  deleteSettingsActions,
  getDomainSettingsAction,
  searchSettingsAction,
  toggleAccountSettingActions,
} from '../../store/actions/domain-settings.actions';

export interface State {
  settings?: DomainSettingsList;
  searchQuery?: string;
}

export const initialState: State = {
  settings: { items: [] },
};

const domainSettingsReducer = createReducer(
  initialState,
  on(getDomainSettingsAction.success, (state, { settings }) => ({
    ...state,
    settings,
  })),
  on(searchSettingsAction.search, (state, { searchQuery }) => ({
    ...state,
    searchQuery,
  })),
  on(deleteSettingsActions.success, (state, { accountId }) => ({
    ...state,
    settings: {
      ...state.settings,
      items: state.settings.items.filter(
        (item) => item.accountId !== accountId,
      ),
    },
  })),
  on(toggleAccountSettingActions.success, (state, { accountId, enabled }) => ({
    ...state,
    settings: {
      items: state.settings.items.map((item) =>
        item.accountId === accountId ? { ...item, enabled } : item,
      ),
    },
  })),
);

export const reducer = (state: State | undefined, action: Action) =>
  domainSettingsReducer(state, action);

export const getDomainSettings = (state: State) => state.settings.items;
export const getSearchQuery = (state: State) => state.searchQuery;
